import {useState, useEffect} from 'react';
import { Grid, Button, Typography } from '@mui/material';
import StockInMgmt from 'components/stockorder/page/StockInMgmt';

export default function AddStockOrderActionImpl(){

    return (
        <>
        <StockInMgmt/>
        </>
    )
}